import {PropertyPath} from "./common";

function toArray<T>(arr: T | readonly T[]): T[] {
    if (arr === undefined || arr === null) {
        return [];
    }
    return (Array.isArray(arr) ? arr : [arr]) as T[];
}

export default function get<ValueType, ObjectType extends object>(record: ObjectType, path: PropertyPath): ValueType | null {
    // Skip if path is empty
    if (!path && typeof path !== 'number') {
        return (record as unknown) as ValueType;
    }

    const pathList = toArray(path);

    let current: any = record;

    for (let i = 0; i < pathList.length; i += 1) {
        if (!current) {
            return null;
        }

        const prop = pathList[i]!;
        current = current[prop];
    }

    return current as ValueType;
}
